<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    menu-props="offsetY"
    top
  >
    <a
      slot="activator"
      class="title"
    >...</a>
    <v-card>
      <v-data-table
        :headers="goodsHeaders"
        :items="goodsItems"
        :loading="loading"
        class="elevation-1"
        hide-actions
        no-data-text="Данных нет"
        style="overflow: auto;"
      >
        <template
          slot="headers"
          slot-scope="props"
        >
          <template v-for="(headers, index) in props.headers">
            <tr :key="index">
              <th
                v-for="(pHeader, pIndex) in headers.parents"
                :key="`${pIndex}parent`"
                :rowspan="pHeader.rowspan"
                :colspan="pHeader.colspan"
                class="table-cell"
                :style="{
                  maxWidth: pHeader.width ? `${pHeader.width}px` : 'auto',
                  minWidth: pHeader.width ? `${pHeader.width}px` : 'auto',
                  width: pHeader.width ? `${pHeader.width}px` : 'auto',
                  whiteSpace: pHeader.width ? 'normal' : 'nowrap'
                }"
              >
                {{ pHeader.title }}
              </th>
            </tr>
            <tr
              v-if="headers.children.length"
              :key="`${index}children`"
              style="height: 35px"
            >
              <th
                v-for="(cHeader, cIndex) in headers.children"
                :key="`${cIndex}child`"
                class="table-cell"
              >
                {{ cHeader.title }}
              </th>
            </tr>
          </template>
        </template>
        <template
          slot="items"
          slot-scope="props"
        >
          <td class="pre-formatted-title px-2">
            {{ props.item.title }}
          </td>
          <td class="pre-formatted px-2">
            {{ props.item.request }}
          </td>
          <td class="pre-formatted px-2">
            {{ props.item.shipping }}
          </td>
          <td class="pre-formatted px-2">
            {{ props.item.goodsDetails }}
          </td>
          <template v-if="showTableCell(props.item)">
            <td
              v-for="(route, index) in props.item.routes"
              :key="`${index}route`"
              class="pre-formatted"
            >
              {{ route }}
            </td>
          </template>
          <template v-if="showTableCell(props.item)">
            <td
              v-for="(warehouse, index) in props.item.warehouses"
              :key="`${index}warehouse`"
              class="pre-formatted"
            >
              {{ warehouse }}
            </td>
          </template>
          <td
            v-if="showTableCell(props.item)"
            class="pre-formatted"
          >
            {{ props.item.accepted }}
          </td>
          <template v-if="showTableCell(props.item)">
            <td
              v-for="(rest, index) in props.item.rest"
              :key="`${index}rest`"
              class="pre-formatted"
            >
              {{ rest }}
            </td>
          </template>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-spacer />
        <v-btn
          small
          flat
          @click="menu = false"
        >
          Закрыть
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { getGoodsSummary } from "../../../../backend/shippingsApi.js";

export default {
  props: ["id", "allowVisible"],
  data() {
    return {
      menu: false,
      headers: [
        {
          title: "Характеристика товара",
          name: "",
          width: 150,
          visible: true,
          sortable: false,
        },
        {
          title: "Заявка",
          name: "request",
          width: 150,
          visible: true,
          sortable: false,
        },
        {
          title: "Инфо по поставке",
          name: "shipping",
          width: 150,
          visible: true,
          sortable: false,
        },
        {
          title: "Описание товаров",
          name: "goodsDetails",
          width: 150,
          visible: true,
          sortable: false,
        },
        {
          title: "Заезд",
          name: "route",
          dynamicCell: true,
          dynamicTitle: true,
          path: "routes",
          width: 150,
          visible: true,
          sortable: false,
        },
        {
          title: "Свозка",
          name: "warehouse",
          dynamicCell: true,
          dynamicTitle: true,
          path: "warehouses",
          width: 150,
          visible: true,
          sortable: false,
        },
        {
          title: "Склад Киев",
          name: "warehouseKiev",
          path: "warehouseKiev",
          sortable: false,
          visible: true,
          children: [
            {
              title: "Принято",
              name: "accepted",
              dynamicTitle: true,
              path: "accepted",
              width: 120,
              visible: true,
              sortable: false,
            },
            {
              title: "Остаток",
              name: "rest",
              dynamicCell: true,
              dynamicTitle: true,
              path: "rest",
              width: 120,
              visible: true,
              sortable: false,
            },
          ],
        },
      ],
      goodsSummary: null,
      loading: false,
    };
  },
  computed: {
    goodsItems() {
      if (!this.goodsSummary) {
        return [];
      }

      const items = [
        {
          title: "Объем, м3",
          request: this.goodsSummary.request?.volume,
          shipping: this.goodsSummary.shipping?.volume,
          goodsDetails: this.goodsSummary.goodsDetails?.volume || null,
          routes: this.goodsSummary.routes.length
            ? [...this.goodsSummary.routes.map(r => r.value?.volume)]
            : [],
          warehouses: this.goodsSummary.warehouses.length
            ? [...this.goodsSummary.warehouses.map(w => w.value?.volume)]
            : [],
          accepted:
            this.goodsSummary.warehouseKiev.accepted?.value?.volume || null,
          rest: this.goodsSummary.warehouseKiev.rest.length
            ? [
              ...this.goodsSummary.warehouseKiev.rest.map(
                wr => wr.value?.volume,
              ),
            ]
            : [],
          roles: ["client"],
        },
        {
          title: "Количество грузовых мест",
          request: this.goodsSummary.request?.cargoPlace,
          shipping: this.goodsSummary.shipping?.cargoPlace,
          goodsDetails: this.goodsSummary.goodsDetails?.cargoPlace,
          routes: this.goodsSummary.routes.length
            ? [...this.goodsSummary.routes.map(r => r.value?.cargoPlace)]
            : [],
          warehouses: this.goodsSummary.warehouses.length
            ? [...this.goodsSummary.warehouses.map(w => w.value?.cargoPlace)]
            : [],
          accepted: this.goodsSummary.warehouseKiev.accepted?.value?.cargoPlace,
          rest: this.goodsSummary.warehouseKiev.rest.length
            ? [
              ...this.goodsSummary.warehouseKiev.rest.map(
                wr => wr.value?.cargoPlace,
              ),
            ]
            : [],
          roles: ["client"],
        },
        {
          title: "Размеры",
          request: this.goodsSummary.request?.cargoSize?.replace(/; /g, "\n"),
          shipping: this.goodsSummary.shipping?.cargoSize?.replace(/; /g, "\n"),
          goodsDetails:
            this.goodsSummary.goodsDetails?.cargoSize?.replace(/; /g, "\n") ||
            null,
          routes: this.goodsSummary.routes.length
            ? [
              ...this.goodsSummary.routes.map(r =>
                  r.value?.cargoSize?.replace(/; /g, "\n"),
              ),
            ]
            : [],
          warehouses: this.goodsSummary.warehouses.length
            ? [
              ...this.goodsSummary.warehouses.map(w =>
                  w.value?.cargoSize?.replace(/; /g, "\n"),
              ),
            ]
            : [],
          accepted:
            this.goodsSummary.warehouseKiev.accepted?.value?.cargoSize?.replace(
              /; /g,
              "\n"
            ) || null,
          rest: this.goodsSummary.warehouseKiev.rest.length
            ? [
              ...this.goodsSummary.warehouseKiev.rest.map(wr =>
                  wr.value?.cargoSize.replace(/; /g, "\n"),
              ),
            ]
            : [],
          roles: ["client"],
        },
        {
          title: "Способ упаковки",
          request: this.goodsSummary.request?.packageType,
          shipping: this.goodsSummary.shipping?.packageType,
          goodsDetails: this.goodsSummary.goodsDetails?.packageType || null,
          routes: this.goodsSummary.routes.length
            ? [
              ...this.goodsSummary.routes.map(r =>
                  r.value?.packageType?.replace(/; /g, "\n"),
              ),
            ]
            : [],
          warehouses: this.goodsSummary.warehouses.length
            ? [
              ...this.goodsSummary.warehouses.map(w =>
                  w.value?.packageType?.replace(/; /g, "\n"),
              ),
            ]
            : [],
          accepted:
            this.goodsSummary.warehouseKiev.accepted?.value?.packageType ||
            null,
          rest: this.goodsSummary.warehouseKiev.rest.length
            ? [
              ...this.goodsSummary.warehouseKiev.rest.map(wr =>
                  wr.value?.packageType.replace(/; /g, "\n"),
              ),
            ]
            : [],
          roles: ["client"],
        },
        {
          title: "Брутто, кг",
          request: this.goodsSummary.request?.weightBrutto,
          shipping: this.goodsSummary.shipping?.weightBrutto,
          goodsDetails: this.goodsSummary.goodsDetails?.weightBrutto,
          routes: this.goodsSummary.routes.length
            ? [...this.goodsSummary.routes.map(r => r.value?.weightBrutto)]
            : [],
          warehouses: this.goodsSummary.warehouses.length
            ? [...this.goodsSummary.warehouses.map(w => w.value?.weightBrutto)]
            : [],
          accepted: this.goodsSummary.warehouseKiev.accepted?.value
            ?.weightBrutto,
          rest: this.goodsSummary.warehouseKiev.rest.length
            ? [
              ...this.goodsSummary.warehouseKiev.rest.map(
                wr => wr.value?.weightBrutto,
              ),
            ]
            : [],
          roles: ["client"],
        },
        {
          title: "Стоимость партии груза",
          request: this.goodsSummary.request?.invoiceSum,
          shipping: this.goodsSummary.shipping?.invoiceSum,
          goodsDetails: this.goodsSummary.goodsDetails?.invoiceSum,
          routes: this.goodsSummary.routes.length
            ? [...this.goodsSummary.routes.map(r => r.value?.invoiceSum)]
            : [],
          warehouses: this.goodsSummary.warehouses.length
            ? [...this.goodsSummary.warehouses.map(w => w.value?.invoiceSum)]
            : [],
          accepted: this.goodsSummary.warehouseKiev.accepted?.value?.invoiceSum,
          rest: this.goodsSummary.warehouseKiev.rest.length
            ? [
              ...this.goodsSummary.warehouseKiev.rest.map(
                wr => wr.value?.invoiceSum,
              ),
            ]
            : [],
          roles: ["client"],
        },
      ];

      if (this.allowVisible) {
        return items
          .filter(
            g =>
              Object.prototype.hasOwnProperty.call(g, "roles") &&
              items.roles.indexOf("client") != -1,
          )
          .map(i => {
            return { ...i };
          });
      }
      return items;
    },
    visibleHeaders() {
      if (!this.goodsSummary) {
        return [];
      }
      const columns = [
        ...this.headers.map(h => {
          if (h.name === "route" && !this.goodsSummary.routes.length) {
            h.visible = false;
          } else if (
            h.name === "warehouse" &&
            !this.goodsSummary.warehouses.length
          ) {
            h.visible = false;
          } else if (
            h.name === "warehouseKiev" &&
            !this.goodsSummary.warehouseKiev.accepted &&
            !this.goodsSummary.warehouseKiev.rest.length
          ) {
            h.visible = false;
          }
          return h;
        }),
      ];
      return columns.filter(i => i.visible);
    },
    goodsHeaders() {
      if (!this.goodsSummary) {
        return [];
      }

      const headers = [];
      const children = [];

      this.visibleHeaders.forEach(h => {
        if (h.dynamicCell && h.dynamicTitle) {
          if (this.goodsSummary[h.path].length) {
            for (let i = 0; i <= this.goodsSummary[h.path].length - 1; i++) {
              headers.push({
                title: `${h.title}\u00A0${this.goodsSummary[h.path][i].title}`,
                name: `${h.name}${i + 1}`,
                dynamicCell: h.dynamicCell,
                dynamicTitle: h.dynamicTitle,
                path: h.path,
                width: h.width,
                visible: h.visible,
                sortable: h.sortable,
              });
            }
          }
        } else {
          headers.push({ ...h });
        }
      });

      const headerItems = headers.map(h => {
        if (h.children && h.children.length) {
          h.children.forEach(c => {
            if (c.dynamicCell && c.dynamicTitle) {
              if (this.goodsSummary[h.path][c.path].length >= 1) {
                for (
                  let i = 0;
                  i <= this.goodsSummary[h.path][c.path].length - 1;
                  i++
                ) {
                  children.push({
                    title: `${c.title}\u00A0${this.$options.filters.date(
                      this.goodsSummary[h.path][c.path][i].date,
                    )}`,
                    name: `${c.name}${i + 1}`,
                    dynamicCell: c.dynamicCell,
                    dynamicTitle: c.dynamicTitle,
                    path: c.path,
                    width: c.width,
                    visible: c.visible,
                    sortable: c.sortable,
                  });
                }
              }
            } else if (c.dynamicTitle) {
              children.push({
                title: `${c.title}\u00A0${this.$options.filters.date(
                  this.goodsSummary[h.path][c.path]?.date,
                ) || ""}`,
                name: c.name,
                dynamicTitle: c.dynamicTitle,
                path: c.path,
                width: c.width,
                visible: c.visible,
                sortable: c.sortable,
              });
            } else {
              children.push(...h.children);
            }
          });

          return {
            rowspan: 1,
            colspan: children.length,
            title: h.title,
            dynamicCell: h.dynamicCell,
            dynamicTitle: h.dynamicTitle,
            path: h.path,
            width: h.width,
            visible: h.visible,
            sortable: h.sortable,
          };
        }

        return {
          rowspan: 2,
          colspan: 1,
          title: h.title,
          dynamicCell: h.dynamicCell,
          dynamicTitle: h.dynamicTitle,
          path: h.path,
          width: h.width,
          visible: h.visible,
          sortable: h.sortable,
        };
      });

      return [
        {
          children,
          parents: headerItems,
        },
      ];
    },
  },
  watch: {
    menu(value) {
      if (value) {
        this.loadData();
      }
    },
  },
  methods: {
    async loadData() {
      if (!this.id) {
        return;
      } else {
        this.loading = true;
        this.goodsSummary = await getGoodsSummary(this.id);
        this.loading = false;
      }
    },
    showTableCell(item) {
      for (const key in item) {
        if (Array.isArray(item[key]) && item[key].length) {
          return true;
        } else if (typeof item[key] !== Array && Object.values(item)) {
          return true;
        } else {
          return false;
        }
      }
    },
  },
};
</script>
<style>
.table-cell {
  border-left: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
}
.pre-formatted {
  white-space: pre-line;
  width: 30%;
}
.pre-formatted-title {
  white-space: pre-line;
  width: 10%;
}
</style>
